import React, { useState } from "react";
import AppContainer from "../../../components/AppContainer";
import { Grid, MenuItem, Stack, Typography } from "@mui/material";
import GlobalButton from "../../../components/CustomButton";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import globalStyle from "../../../globalStyle";
import CustomDropDown from "../../../components/CutomDropDown";
import AddInstallments from "./AddInstallments";
import AddSections from "./AddSections";

const AddEditNewClasses = () => {
  const [installments, setInstallment] = useState([
    {
      type: "",
      fee: 0,
      date: null,
      installmentNo: 1,
    },
  ]);

  const [classSections, setClassSections] = useState([
    {
      strength: 0,
      section: "",
      subjects: [
        {
          name: "",
          teachBy: "",
          totalMarks: 0,
          passingMarks: 0,
          author: "",
        },
      ],
    },
  ]);

  // Render right parts
  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <GlobalButton
          btnText={"Create New Class"}
          //   handleClickBtn={() => uploadTranscriptRef.current.click()}
          styleProps={{
            height: 45,
            width: "auto",
          }}
        />
      </Stack>
    );
  };

  return (
    <AppContainer
      primaryHeading={"Add New Class"}
      secondaryHeading={"Please enter class details"}
      headProps={renderRightPart()}
    >
      <Typography mb={1} variant="h6" fontWeight={500}>
        Class Information
      </Typography>

      <Grid container mb={2} spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Label labelText="Class Name" required htmlFor={"class_name"} />
          <TextInput
            id={"class_name"}
            required
            placeholder={"Enter class name"}
            styleProps={globalStyle.textField}
            type={"text"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label
            labelText="Total Strength"
            required
            htmlFor={"class_strength"}
          />
          <TextInput
            id={"class_strength"}
            required
            placeholder={"Enter class strength"}
            styleProps={globalStyle.textField}
            type={"number"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label
            labelText="Admission Fee Structure"
            required
            htmlFor={"class_fee_structure"}
          />
          <CustomDropDown>
            <MenuItem>Installment</MenuItem>
            <MenuItem>One Time Payment</MenuItem>
          </CustomDropDown>
        </Grid>
      </Grid>

      <Typography mb={1} variant="h6" fontWeight={500}>
        Fee Structure
      </Typography>

      <Grid container mb={2} spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Label
            labelText="Tuition Fee"
            required
            htmlFor={"class_tuition_fee"}
          />
          <TextInput
            id={"class_tuition_fee"}
            required
            placeholder={"Enter tuition fee"}
            styleProps={globalStyle.textField}
            type={"number"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label
            labelText="Annual Funds"
            required
            htmlFor={"class_annual_funds"}
          />
          <TextInput
            id={"class_annual_funds"}
            required
            placeholder={"Enter annual funds"}
            styleProps={globalStyle.textField}
            type={"number"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label
            labelText="Sports /  Other fee"
            required
            htmlFor={"class_fee_structure"}
          />
          <TextInput
            id={"class_fee_structure"}
            required
            placeholder={"Enter sports / other fee"}
            styleProps={globalStyle.textField}
            type={"number"}
          />
        </Grid>
      </Grid>
      <AddInstallments
        installments={installments}
        setInstallment={setInstallment}
      />
      <Typography mb={1} variant="h6" fontWeight={500} textAlign={"right"}>
        Total 1500 USD
      </Typography>

      {/* Add Sections */}
      <AddSections
        classSections={classSections}
        setClassSections={setClassSections}
      />
    </AppContainer>
  );
};

export default AddEditNewClasses;
